var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconProgressWeekly(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47188 0.196872L0.971875 2.63437C0.3875 2.85312 0 3.41562 0 4.04062V11.075C0 11.6437 0.321875 12.1625 0.828125 12.4156L7.32812 15.6656C7.75 15.8781 8.24687 15.8781 8.66875 15.6656L15.1687 12.4156C15.6781 12.1625 15.9969 11.6406 15.9969 11.075V4.04062C15.9969 3.41562 15.6094 2.85625 15.025 2.6375L8.525 0.199997C8.1875 0.0687474 7.8125 0.0687474 7.47188 0.196872ZM8 2.1375L14 4.3875V4.42187L8 6.85937L2 4.42187V4.3875L8 2.1375ZM9 13.2625V8.60937L14 6.57812V10.7625L9 13.2625Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProgressWeekly);
export default __webpack_public_path__ + "static/media/icon--progress-weekly.513daef3a6d4cf488339a34c4f1b6964.svg";
export { ForwardRef as ReactComponent };